<dgx-components-panel
  *ngIf="applianceCPG"
  [border]="border"
  [rounded]="rounded"
  [variant]="variant"
>
  <div class="registration-confirmation-cpg__content-container">
    <h5>
      {{ applianceCPG.title }}
    </h5>
    <div class="image mt-2 mb-2">
      <dgx-components-picture
        [alt]="'cpg-image'"
        [aspectRatio]="'5:6'"
        [fit]="'contain'"
        src="assets/images/cpg-products/{{ applianceCPG.filter }}.png"
      />
    </div>

    <h5>
      {{ applianceCPG.productTitle }}
    </h5>

    <p class="mb-4">{{ applianceCPG.description }}</p>

    <ng-container *ngIf="!codeCopied; else copiedText">
      <a
        (click)="copyPromoCode()"
        class="registration-confirmation-cpg__copy-to-clipboard mt-4 mb-4"
      >
        <span>
          <dgx-components-icon
            [icon]="'copy'"
            [size]="'sm'"
            class="mr-2" /></span
        >{{ 'SHARED_UI_REGISTRATION_COPY_YOUR_CODE' | translate }}
      </a>
    </ng-container>

    <a
      href="{{ applianceCPG.waterFilterUrl }}"
      class="registration-confirmation-cpg__link-cta typog-h6"
      target="_blank"
      ><dgx-components-button>{{ applianceCPG.cta }}</dgx-components-button></a
    >
  </div>

  <ng-template #copiedText>
    <a
      (click)="copyPromoCode()"
      class="registration-confirmation-cpg__copy-to-clipboard mt-4 mb-4"
    >
      <span
        ><dgx-components-icon
          [icon]="'clipboard-check'"
          [size]="'sm'"
          class="mr-2" /></span
      >Code copied
    </a>
  </ng-template>
</dgx-components-panel>
